import { QueryParamsBase } from 'api/search';
export const reload = () => window.location.reload();

type URLSearchParamsInputFormat = Record<string, string>;

export const cleanObject = (obj: QueryParamsBase): URLSearchParamsInputFormat =>
  Object.entries(obj).reduce<URLSearchParamsInputFormat>(
    (acc, [key, value]) =>
      value !== null && value !== undefined && value !== ''
        ? { ...acc, [key]: String(value) }
        : acc,
    {},
  );

export const pageParamFromString = (
  type: 'query' | 'responseSize',
  param: string,
): QueryParamsBase => {
  return Object.fromEntries(new URLSearchParams({ [type]: param }));
};

export const buildUrlWithSearchParams = (
  path: string,
  params?: Record<string, any>,
): string =>
  params && Object.keys(params).length > 0
    ? `${path}?${new URLSearchParams(params)}`
    : path;
